import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './components/layout/MainLayout';
import HomePage from './pages/HomePage';
import CategoryPage from './pages/CategoryPage';
import FootballPage from './pages/FootballPage';
import TopScorersPage from './pages/TopScorersPage';
import NotFoundPage from './pages/NotFoundPage';
import useDarkMode from './hooks/useDarkMode';
import './styles/globals.css';

function App() {
  const { isDark, toggle: toggleDarkMode } = useDarkMode();
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  return (
    <Router>
      <MainLayout 
        isDark={isDark} 
        toggleDarkMode={toggleDarkMode}
        onSearch={handleSearch}
      >
        <Routes>
          <Route path="/" element={<HomePage searchQuery={searchQuery} />} />
          <Route path="/puan-durumu" element={<FootballPage />} />
          <Route path="/gol-krallari" element={<TopScorersPage />} />
          <Route path="/:categorySlug" element={<CategoryPage searchQuery={searchQuery} />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </MainLayout>
    </Router>
  );
}

export default App;
